import {Grid} from "@material-ui/core";
import styles from "../styles/ProduseParticipante.module.scss";
import React from "react";
import {makeStyles} from "@material-ui/core";
//import Carousel from "../components/Carousel";
import Products from "./Products";




const containerStyles = makeStyles(theme => ({

        root: {
            background: '#fff',
            textAlign: "center",
            marginTop: '-3px'
        },



}))

function ProduseParticipante(props: any = {}) {

    // let produse = [
    //     {name: 'cremosso_afine_125g', label: 'Cremosso Afine 125g'},
    //     {name: 'cremosso_capsuni_125g', label: 'Cremosso Căpșuni 125g'},
    //     {name: 'cremosso_natur_125g', label: 'Cremosso Natur 125g'},
    //     {name: 'cremosso_piersici_125g', label: 'Cremosso Piersici 125g'},
    //     {name: 'cremosso_stracciatella_125g', label: 'Cremosso Stracciatella 125g'},
    //     {name: 'cremosso_visine_125g', label: 'Cremosso Vișine 125g'},
    //     {name: 'cremosso_natur_400g', label: 'Cremosso Natur 400g'},
    //     {name: 'cremosso_pere_400g', label: 'Cremosso Pere 400g'},
    //     {name: 'cremosso_piersici_400g', label: 'Cremosso Piersici 400g'},
    //     {name: 'cremosso_stracciatella_400g', label: 'Cremosso Stracciatella 400g'},
    //     {name: 'cremosso_visine_400g', label: 'Cremosso Vișine 400g'},
    //     {
    //         name: 'cremosso_natur_multipack_8_125g', label: 'Cremosso Natur\n' +
    //             'pachet promo 7+1'
    //     },
    //     {
    //         name: 'cremosso_capsuni_si_piersici_multipack_8_125g', label: 'Capșuni/Piersici\n' +
    //             'pachet promo 7+1'
    //     },
    //     {
    //         name: 'cremosso_stracciatella_si_visine_multipack_8_125g', label: 'Cremosso Stracciatella\n' +
    //             'pachet promo 7+1'
    //     },
    //     {
    //         name: 'cremosso_visine_si_afine_multipack_8_125g', label: 'Cremosso Vișine/Afine\n' +
    //             'pachet promo 7+1'
    //     },
    // ];
    let classStyles = containerStyles();
    // const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.only('xs'));

    return <Grid ref={props.forwardRef || null} container className={classStyles.root}>

        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12} sm={1} >&nbsp;</Grid>
        <Grid item xs={12} sm={10}>
            <Products/>
            {/*<Typography variant="h3" color={"primary"} display={"block"} component="div">*/}
            {/*    <strong>Produse participante</strong>*/}
            {/*    <br/><br/>*/}
            {/*    <br />*/}
            {/*    <Carousel show={isMobile ? 1 : 5} infiniteLoop={true}>*/}
            {/*        {produse.map((prod, idx) => {*/}
            {/*            return <div key={idx}>*/}
            {/*                <div className={prod.name}></div>*/}
            {/*                <div className={'product-name'}>{prod.label}</div>*/}
            {/*            </div>*/}
            {/*        })}*/}
            {/*    </Carousel>*/}
            {/*</Typography>*/}
        </Grid>

        <Grid item xs={12} className={styles.containerWrapperStyles}>

        </Grid>
    </Grid>

}

export default ProduseParticipante;
